import script from "./TalentCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TalentCard.vue?vue&type=script&setup=true&lang=js"

import "./TalentCard.vue?vue&type=style&index=0&id=1b526dee&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/employer/employer/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b526dee"]])

export default __exports__